// The browser's IANA time zone, or undefined when the browser won't say.
// The server keeps it only if it is a name it knows (#304: the weekly scan
// summary comes on Monday morning local time).
export function browserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined
  } catch {
    return undefined
  }
}
